import { render, staticRenderFns } from "./IncomeRecord.vue?vue&type=template&id=a02ac770&scoped=true&"
import script from "./IncomeRecord.vue?vue&type=script&lang=js&"
export * from "./IncomeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02ac770",
  null
  
)

export default component.exports